import { Roles } from '../constants/roles'
import { store } from '../core/store'

export const isRole = (roleToCheck: 'admin' | 'fingerbox'): boolean | undefined => {
  const roles = store.getState().roles

  switch (roleToCheck) {
    case 'admin':
      return roles.includes(Roles.MANAGE_USERS)
    case 'fingerbox':
      return roles.includes(Roles.MANAGE_PATIENT) && !roles.includes(Roles.MANAGE_USERS)
  }
}

// 新增：检查KPI权限的函数
export const hasKpiPermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看KPI
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_KPI_OVERVIEW)
}

// 新增：检查Participation权限的函数
export const hasParticipationPermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Participation
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_PARTICIPATION)
}

// 新增：检查Transaction权限的函数
export const hasTransactionPermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Transaction
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_TRANSACTION)
}

// 新增：检查Scorecard权限的函数
export const hasScorecardPermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Scorecard
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_SCORECARD)
}

// 新增：检查Store Performance权限的函数
export const hasStorePerformancePermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Store Performance
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_STORE_PERFORMANCE)
}

// 新增：检查Store Promotion权限的函数
export const hasStorePromotionPermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Store Promotion
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_STORE_PROMOTION)
}

// 新增：检查Store District Heatmap权限的函数
export const hasStoreDistrictHeatmapPermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Store District Heatmap
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_STORE_DISTRICT_HEATMAP)
}

// 新增：检查Patient Performance权限的函数
export const hasPatientPerformancePermission = (): boolean => {
  const roles = store.getState().roles
  // 只有管理员（有MANAGE_USERS权限）才能查看Patient Performance
  return roles.includes(Roles.MANAGE_USERS) && roles.includes(Roles.VIEW_PATIENT_PERFORMANCE)
}
